<template>
  <div class="c-product-wrapper">
    <div class="banner">
      <!-- <img :src="banner" alt="" /> -->
      <CardFlip :cards="classify_1" @onCardItemClick="onCardItemClick" />
    </div>
    <div class="container">
      <ProductCategory @selectProductCategory="selectProductCategory" />
      <div class="product-list">
        <ProductSelectBar
          :classify_1="classify_1"
          :classify_1_ID="classify_1_ID"
          :classify_2="classify_2"
          @onClassifySelect="onClassifySelect"
        />

        <ol>
          <li
            v-for="item in productList"
            :key="item.FInterID"
            @click="seeProduct(item)"
          >
            <div class="img-wrap">
              <!-- <img v-if="item.WebSite" :src="item.WebSite" alt="" /> -->
              <el-image
                style="width: 100%; height: 100%;"
                lazy
                :src="item.WebSite"
                fit="contain"
              >
                <div
                  slot="placeholder"
                  style="position: absolute;top:50%;left:50%;transform:translate(-50%,-50%)"
                >
                  <i class="iconfont icon-jiazai" style="font-size: 28px;"></i>
                </div>
              </el-image>
            </div>
            <p>{{ item[getName("product")] }}</p>
          </li>
        </ol>

        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategory from "@/components/pc/ProductCategory/ProductCategory.vue";
import CardFlip from "@/components/pc/CardFlip/CardFlip.vue";
import ProductSelectBar from "@/components/pc/ProductSelectBar/ProductSelectBar.vue";

export default {
  components: {
    ProductCategory,
    CardFlip,
    ProductSelectBar
  },
  data() {
    return {
      //   banner: "",
      classify_1: [], // 一级分类
      classify_1_ID: "",
      classify_2: [], // 二级分类
      classify_2_ID: "",
      FType: -1,
      productList: [],
      pagination: {
        pageSize: 18,
        currentPage: 1,
        total: 0
      },
      searchVal: ""
    };
  },
  mounted() {
    // const params = {
    //   Data: {
    //     FInterID: 8
    //   }
    // };
    // this.$store.dispatch("getIndexBodyData", params).then(res => {
    //   this.banner = res.Data.WebSite;
    // });
    const params = {
      Data: {
        ItemParentID: 352
      }
    };
    this.$store.dispatch("getProductCategoryData", params).then(res => {
      this.classify_1 = res;
      this.classify_1_ID = res[0]?.ID;
      //   this.classify_2 = res[0]?.Childs;
      this.classify_2_ID = res[0]?.Childs[0]?.ID;
      this.getProdtcuList();
    });
  },
  methods: {
    getProdtcuList() {
      const params = {
        Data: {
          FType: this.FType,
          PageSize: this.pagination.pageSize,
          PageIndex: this.pagination.currentPage,
          NewFType:
            this.classify_2_ID && this.classify_2_ID != "-1"
              ? this.classify_2_ID
              : this.classify_1_ID
        }
      };

      params.Data[this.getName("product")] = this.searchVal;

      this.$store
        .dispatch("getProductList", params)
        .then(res => {
          this.productList = res.Data;
          this.pagination.total = res.TotalNumber;
        })
        .catch(res => {
          this.$message({
            message: res,
            type: "warning"
          });
        });
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getProdtcuList();
    },
    selectProductCategory(id) {
      this.FType = id;
      this.handleCurrentChange();
    },
    seeProduct(item) {
      if (item.FUrl) {
        window.open(item.FUrl, "_blank");
      } else {
        const that = this;
        this.$alert(that.$t("other.contactService"), that.$t("other.prompt"), {
          confirmButtonText: "OK",
          type: "info"
        });
      }
    },
    // 获取当前使用名称
    getName(type) {
      let name = "";

      switch (this.$i18n.locale) {
        case "zh":
          name = type === "product" ? "FName" : "ItemName";
          break;
        case "en":
          name = "EnglishName";
          break;
        case "sp":
          name = "xibanyaName";
          break;
      }

      return name;
    },
    // 点击分类卡片
    onCardItemClick(item) {
      this.classify_1_ID = item.ID;
      this.classify_2 = item.Childs;

      this.handleCurrentChange();
    },
    // 选择新分类
    onClassifySelect(e) {
      const { level, ID } = e;
      if (level === 1) {
        this.classify_1_ID = ID;
        const index = this.classify_1.findIndex(v => {
          return v.ID === ID;
        });
        this.classify_2 = this.classify_1[index].Childs;
        this.classify_2_ID = "";
        // this.classify_2_ID = this.classify_1[index].Childs[0].ID;
      } else {
        this.classify_2_ID = ID;
      }

      this.handleCurrentChange();
    }
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.searchVal && this.$route.query.searchVal !== "") {
          this.searchVal = this.$route.query.searchVal;
          this.handleCurrentChange();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="less">
@import "~@/assets/style/variables.less";

.c-product-wrapper {
  .container {
    width: 1200px;
    margin: 30px auto 60px;
    display: flex;

    .product-list {
      margin-left: 20px;
      flex: 1;

      ol {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-bottom: 40px;

        li {
          width: 283px;
          height: 246px;
          box-shadow: 0px 0px 6px rgba(0, 100, 178, 0.3);
          margin: 0 20px 20px 0;
          cursor: pointer;

          .img-wrap {
            width: 283px;
            height: 214px;

            // img {
            //   display: block;
            //   width: 100%;
            //   height: 100%;
            //   object-fit: contain;
            // }
          }

          p {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 31px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 10px;
            text-align: center;
          }
        }

        li:nth-child(3n + 3) {
          margin: 0 0 20px 0;
        }

        li:hover {
          box-shadow: 0px 0px 12px rgba(0, 100, 178, 0.3);
        }
      }
    }
  }
}
</style>
